<script>
import ImgUpload from '@/imgUpload.vue'
import XEUtils from "xe-utils"
import AssayAddress from "@/components/address/assayAddress.vue"

export default {
  data() {
    return {
      data: {},
      rules: {
        tenantName: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
        name: [{ required: true, message: '请输入化验室名称', trigger: 'blur' }],
        contactPhone: [{ required: true, message: '请输入化验室手机号', trigger: 'blur' }],
        payType: [{ required: true, message: '请选择收款方式', trigger: 'change' }],
        startTime: [{ required: true, message: '请选择开始营业时间', trigger: 'change' }],
        endTime: [{ required: true, message: '请选择结束营业时间', trigger: 'change' }],
        address: [{ required: true, message: '请选择地址', trigger: 'change' }],
        headImg: [{ required: true, message: '请上传门头图片', trigger: 'change' }],
        contentImgs: [{ required: true, message: '请上传门店具体图片', trigger: 'change' }]
      },
      qualificationList: [
        { code: 'CMA', name: 'CMA资质' },
        { code: 'CNAS', name: 'CNAS资质' }
      ],
      loading: false,
      imgs: ['headImg', 'logoImage', 'officialSealImage', 'businessLicense'],
      companyName: '',
      dialogFormVisible: false,
      companyData: [],
      disabled: false,
      saveLoading: false,
      row: {},
      name: '',
      descriptionList: [],
      projectList: [],
      accounManagerList: [],
      headImgList: [
        'https://hulianuat.oss-cn-beijing.aliyuncs.com/uniapp/assay/assay-img1.png',
        'https://hulianuat.oss-cn-beijing.aliyuncs.com/uniapp/assay/assay-img2.png',
        'https://hulianuat.oss-cn-beijing.aliyuncs.com/uniapp/assay/assay-img3.png'
      ]
    }
  },
  components: { ImgUpload, AssayAddress },
  mounted() {
    this.init()
    this.fetchAccounManagerList()
    this.$validate.ToDocumentTitle()
  },
  methods: {
    init() {
      this.data = {
        qualificationImgs: [],
        contentImgs: [],
        template: [
          {
            name: '',
            headImg: 'https://hulianuat.oss-cn-beijing.aliyuncs.com/uniapp/assay/assay-img1.png',
            project: []
          }
        ],
        payType: '2'
      }
      this.descriptionList = []
      this.projectList = []
      this.$axios.get('/laboratory/coal_laboratory/getLaboratoryIndicatorConfig').then(res => {
        this.descriptionList = res.data.data
        this.descriptionList.forEach(item => {
          item.value.forEach(_item => {
            this.projectList.push(_item)
          })
        })
      })
      setTimeout(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate()
        }
      }, 0)
    },
    keyDownEnter(event) {
      event.preventDefault()
      this.save()
    },
    save() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          if ((!this.data.latitude || !this.data.longitude) && this.data.address) {
            this.$message.error({ showClose: true, message: '地址必须选择坐标!' })
          } else {
            this.loading = true
            try {
              const params = XEUtils.clone(this.data, true)
              this.imgs.forEach(key => {
                params[key] = this.data[key] && this.data[key].length > 0 ? this.data[key][0].url : ''
              })
              if (this.data.qualificationCode && this.data.qualificationCode.length > 0) {
                let qualification = []
                this.qualificationList.forEach((item) => {
                  if (this.data.qualificationCode.includes(item.code)) {
                    qualification.push(item)
                  }
                })
                params['qualification'] = JSON.stringify(qualification)
              } else {
                params['qualification'] = '[]'
              }
              if (this.data.amId) {
                this.accounManagerList.forEach(item => {
                  if (item.amId === this.data.amId) {
                    params['amName'] = item.amName
                    params['amPhone'] = item.amPhone
                  }
                })
              }
              params.template.forEach(item => {
                item.price = Number(item.price)
                item.project = item.project.toString()
                item.description = item.description.join('、')
              })
              this.$axios.post('/laboratory/coal_laboratory/internal/create', params).then(() => {
                this.$message.success({ showClose: true, message: '保存成功！' })
                this.init()
                this.loading = false
              }).catch(() => {
                this.loading = false
              })
            } catch (error) {
              console.log('error', error)
            }
          }
        } else {
          this.$message.warning({ showClose: true, message: '有必填项未填写！' })
          return false
        }
      })
    },
    displayInit(e) {
      if (e.length >= 2) {
        let result = e.replace(/(^\s+)|(\s+$)/g, "");
        this.name = '企业列表'
        this.saveLoading = true
        this.$axios.get(`/account/enterprise/keywordFuzzy?keywordFuzzy=${result}`).then(res => {
          this.companyData = res.data.data
          this.companyData.unshift({
            companyname: result,
            creditno: ''
          })
          this.saveLoading = false
        })
      } else if (e.length === 0) {
        this.name = '历史记录'
        this.companyData = JSON.parse(localStorage.getItem('companyList')) || []
      }
      this.disabled = true
    },
    handleCurrentChange(row) {
      this.row = row
      this.disabled = false
    },
    companySave() {
      this.dialogFormVisible = false
      this.data.tenantName = this.row.companyname
      this.data.tenantCode = this.row.creditno
      this.setCompanyList()
      if (this.$refs.formRef) {
        this.$refs.formRef.clearValidate()
      }
    },
    setCompanyList() {
      let companyList = []
      if (localStorage.getItem('companyList')) {
        companyList = JSON.parse(localStorage.getItem('companyList'))
      }
      if (companyList.length === 0) {
        companyList = [this.row]
      } else if (companyList.length !== 0) {
        companyList.forEach((item, index) => {
          if (item.companyname === this.row.companyname) {
            companyList.splice(index, 1)
          }
        })
        companyList.unshift(this.row)
      }
      localStorage.setItem('companyList', JSON.stringify(companyList))
      this.row = {}
    },
    setCompany() {
      this.dialogFormVisible = true
      this.name = '历史记录'
      this.companyData = JSON.parse(localStorage.getItem('companyList')) || []
      this.companyName = ''
      this.disabled = true
    },
    addTemplate() {
      this.data.template.push({
        name: '',
        headImg: 'https://hulianuat.oss-cn-beijing.aliyuncs.com/uniapp/assay/assay-img1.png',
        project: []
      })
    },
    delTmeplate(index) {
      this.data.template.splice(index, 1)
    },
    handleDescriptionChange(item) {
      if (item.description && item.description.length > 0) {
        let projects = []
        this.descriptionList.forEach((_item) => {
          if (item.description.includes(_item.key)) {
            projects = [...projects, ..._item.value]
            item.project = projects
          }
        })
      } else {
        item.project = []
      }
    },
    fetchAccounManagerList() {
      this.$axios.post('/laboratory/accoun_manager/list', {}).then(res => {
        this.accounManagerList = res.data.data
      })
    },
    updateModelData(event) {
      this.$set(this.data, 'address', event.address)
      this.$set(this.data, 'longitude', event.longitude)
      this.$set(this.data, 'latitude', event.latitude)
      this.$set(this.data, 'province', event.province)
      this.$set(this.data, 'city', event.city)
      this.$set(this.data, 'district', event.district)
    }
  }
}
</script>

<template>
  <div class="system-company">
    <div style="width: 100%; height: 40px; line-height: 40px; text-align: center; border-bottom: 1px solid #ccc;">
      化验室新增
    </div>
    <div style="height: calc(100% - 102px); width: 100%; padding: 20px; box-sizing: border-box; overflow: auto">
      <el-form :model="data" :rules="rules" ref="formRef" label-width="120px" @keydown.enter.prevent="keyDownEnter">
        <el-form-item prop="tenantName" label="企业名称">
          <el-input v-model="data.tenantName" placeholder="请选择企业" readonly
            style="width: calc(100% - 70px); margin-right: 10px"></el-input>
          <el-button type="primary" size="small" @click="setCompany">选择</el-button>
        </el-form-item>
        <el-form-item prop="tenantCode" label="统一社会代码">
          <el-input v-model="data.tenantCode" placeholder="请输入统一社会代码" readonly></el-input>
        </el-form-item>
        <el-form-item prop="name" label="化验室名称">
          <el-input v-model="data.name" placeholder="请输入化验室名称"></el-input>
        </el-form-item>
        <el-form-item prop="contactPhone" label="化验室手机号">
          <el-input v-model="data.contactPhone" placeholder="请输入化验室手机号"></el-input>
        </el-form-item>
        <el-form-item prop="payType" label="收款方式">
          <el-select v-model="data.payType" placeholder="请选择收款方式" style="width: 100%">
            <el-option value="1" label="线上收款"></el-option>
            <el-option value="2" label="线下收款"></el-option>
            <el-option value="3" label="线上线下收款"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="address" label="地址">
          <assay-address :model-value="data.address" :model-data="data" @update-modelData="updateModelData" />
        </el-form-item>
        <el-form-item prop="startTime" label="开始营业时间">
          <el-time-picker v-model="data.startTime" placeholder="请选择开始营业时间" format="HH:mm" value-format="HH:mm"
            style="width: 100%"></el-time-picker>
        </el-form-item>
        <el-form-item prop="endTime" label="结束营业时间">
          <el-time-picker v-model="data.endTime" placeholder="请选择结束营业时间" format="HH:mm" value-format="HH:mm"
            style="width: 100%"></el-time-picker>
        </el-form-item>
        <el-form-item prop="description" label="化验室介绍">
          <el-input v-model="data.description" placeholder="请输入化验室介绍"></el-input>
        </el-form-item>
        <el-form-item prop="amId" label="客户经理">
          <el-select v-model="data.amId" placeholder="请选择客户经理" filterable clearable style="width: 100%;">
            <el-option v-for="(item, index) in accounManagerList" :key="index" :value="item.amId"
              :label="`${item.amName} ${item.amPhone}`"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="化验项" required>
          <template v-for="(item, index) in data.template">
            <el-card style="margin: 10px 0">
              <div class="cf">
                #{{ index + 1 }}
                <div class="fr" v-if="index > 0">
                  <el-button type="danger" @click="delTmeplate(index)">删除</el-button>
                </div>
              </div>
              <el-form-item :prop="`template.${index}.headImg`" label="项目图片" label-width="10">
                <el-radio-group v-model="item.headImg">
                  <el-radio v-for="_item in headImgList" :label="_item" :key="_item">
                    <img :src="_item" style="width: 60px;" alt="">
                  </el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item :prop="`template.${index}.name`" label="化验项名称" label-width="10"
                :rules="[{ required: true, message: '请输入化验项名称', trigger: 'change' }]">
                <el-input v-model="item.name" placeholder="请输入化验项名称"></el-input>
              </el-form-item>
              <el-form-item :prop="`template.${index}.description`" label="化验项目" label-width="10"
                :rules="[{ required: true, message: '请选择化验项目', trigger: 'change' }]">
                <el-select v-model="item.description" placeholder="请选择化验项目" multiple filterable style="width: 100%"
                  @change="handleDescriptionChange(item)">
                  <el-option v-for="_item in descriptionList" :key="_item.key" :value="_item.key" :label="_item.key" />
                </el-select>
              </el-form-item>
              <el-form-item :prop="`template.${index}.project`" label="化验指标" label-width="10"
                :rules="[{ required: true, message: '请选择化验指标', trigger: 'change' }]">
                <el-select v-model="item.project" placeholder="根据化验项目自动带出" multiple disabled style="width: 100%">
                  <el-option v-for="(_item, _index) in projectList" :key="_index" :value="_item"
                    :label="_item"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :prop="`template.${index}.price`" label="价格" label-width="10"
                :rules="[{ required: true, message: '请输入价格', trigger: 'change' }]">
                <el-input v-model="item.price" type="number" placeholder="请输入价格"></el-input>
              </el-form-item>
            </el-card>
          </template>
          <el-button type="primary" @click="addTemplate">新增</el-button>
        </el-form-item>
        <el-form-item prop="qualificationCode" label="资质">
          <el-select v-model="data.qualificationCode" placeholder="请选择资质" multiple style="width: 100%">
            <el-option v-for="item in qualificationList" :value="item.code" :label="item.name" :key="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <img-upload :data="data" :rules="rules" label="资质图片" field="qualificationImgs" :limit="10" :span="24"
          v-if="data.qualificationCode && data.qualificationCode.length > 0" />
        <img-upload :data="data" :rules="rules" label="门头图片" field="headImg" :limit="1" />
        <img-upload :data="data" :rules="rules" label="门店具体图片" field="contentImgs" :limit="10" />
        <img-upload :data="data" :rules="rules" label="营业执照" field="businessLicense" :limit="1" />
        <img-upload :data="data" :rules="rules" label="化验室Logo" field="logoImage" :limit="1" />
        <img-upload :data="data" :rules="rules" label="章模" field="officialSealImage" :limit="1" />
      </el-form>
    </div>
    <div class="footer-save">
      <el-button size="large" type="primary" :loading="loading" @click="save">保 存</el-button>
    </div>
    <el-dialog :visible.sync="dialogFormVisible" v-if="dialogFormVisible" title="选择企业" :append-to-body="true"
      fullscreen>
      <div style="padding: 20px 5px; display: flex; align-items: center;">
        <span style="font-size: 14px; margin-right: 10px; font-weight: bold">{{ name }}</span>
        <el-input v-model.trim="companyName" placeholder="请输入企业名称" style="width: 200px" @input="displayInit($event)"
          clearable></el-input>
      </div>
      <el-table :align="'center'" :data="companyData" height="400px" border @current-change="handleCurrentChange"
        v-loading="saveLoading" highlight-current-row>
        <template #empty>
          <el-empty></el-empty>
        </template>
        <el-table-column prop="companyname" label="企业名称"></el-table-column>
        <el-table-column prop="creditno" label="统一社会代码"></el-table-column>
      </el-table>
      <template #footer>
        <span class="dialog-footer">
          <span class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取消</el-button>
            <el-button type="primary" @click="companySave" :disabled="disabled">确定</el-button>
          </span>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.system-company {
  height: 100%;
  width: 100%;
  overflow: auto;
}

.footer-save {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #ccc;
}
</style>